import { useState } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Radio } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { ThemeToggle } from '@/components/theme-toggle'
import { api, ApiError } from '@/lib/api'
import { queryKeys } from '@/lib/queries'

export function LoginPage() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const login = useMutation({
    mutationFn: () => api.auth.login(username, password),
    onSuccess: async (data) => {
      queryClient.setQueryData(queryKeys.me, { username: data.username })
      await queryClient.invalidateQueries()
      navigate({ to: '/' })
    },
  })

  return (
    <div className='flex min-h-screen flex-col items-center justify-center bg-background p-4'>
      <div className='absolute top-4 right-4'>
        <ThemeToggle />
      </div>
      <div className='mb-6 flex items-center gap-2 text-lg font-semibold'>
        <Radio className='size-6 text-primary' />
        easy-mqtt admin
      </div>
      <Card className='w-full max-w-sm'>
        <CardHeader>
          <CardTitle>Sign in</CardTitle>
          <CardDescription>
            Use a Mosquitto dynamic-security client that holds the <code>admin</code> role.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form
            className='space-y-4'
            onSubmit={(e) => {
              e.preventDefault()
              login.mutate()
            }}
          >
            <div className='space-y-2'>
              <Label htmlFor='username'>Username</Label>
              <Input id='username' value={username} onChange={(e) => setUsername(e.target.value)} autoComplete='username' autoFocus required />
            </div>
            <div className='space-y-2'>
              <Label htmlFor='password'>Password</Label>
              <Input id='password' type='password' value={password} onChange={(e) => setPassword(e.target.value)} autoComplete='current-password' required />
            </div>
            {login.isError && <p className='text-sm text-destructive'>{login.error instanceof ApiError ? login.error.message : 'Sign in failed. Please try again.'}</p>}
            <Button type='submit' className='w-full' disabled={login.isPending}>
              {login.isPending ? 'Signing in…' : 'Sign in'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
